import {shareLink} from "./sharing";
import {getNewFlashmessage} from "./flashmessages";

export function shareItemcardModal(query = document.querySelectorAll('.js-openItemcardSharingModal')) {
    for (const link of query) {
        link.addEventListener("click", function () {
            if (navigator.share && navigator.canShare) {
                if (link.dataset.url && link.dataset.title) {
                    shareLink({
                        title: link.dataset.title,
                        url: link.dataset.url,
                    });
                }
            } else {
                getNewFlashmessage("Sharing not possible with your browser");
            }
        });
    }
}